import { useCallback, useState } from 'react';
import { maskCEP, maskPhone, maskEmail, maskNumber, maskName, maskCPF, maskCNPJ } from '../utils/masks';

const maskMap = {
  cep: maskCEP,
  phone: maskPhone,
  email: maskEmail,
  number: maskNumber,
  name: maskName,
  cpf: maskCPF,
  cnpj: maskCNPJ,
  document: (value, docType) => (docType === 'CNPJ' ? maskCNPJ(value) : maskCPF(value)),
};

export default function useMaskedInput(initialValue = '', type = 'text', options = {}) {
  const [value, setValue] = useState(initialValue);

  const applyMask = useCallback((raw) => {
    const fn = maskMap[type];
    if (!fn) return raw;
    // Support passing docType in options for document
    return type === 'document' ? fn(raw, options.docType) : fn(raw);
  }, [type, options.docType]);

  const onChange = useCallback((eOrValue) => {
    const raw = typeof eOrValue === 'string' ? eOrValue : eOrValue?.target?.value ?? '';
    const masked = applyMask(raw);
    setValue(masked);
    if (options.onChange) options.onChange(masked);
  }, [applyMask, options]);

  return { value, setValue, onChange };
}
